<template>
  <div class="recordContainer">
    <div v-for="item in datas">
      <div style="display: flex; line-height: 1.7">
        <div v-if="item.type != 'array'" class="labelTitle">
          {{ item.name }}：
        </div>
        <div v-if="item.type == 'str'" class="textDescArea">
          <div
            v-if="item.name == '操作结果' && item.value == '通过'"
            class="successColor"
          >
            {{ item.value }}
          </div>
          <div
            v-else-if="item.name == '操作结果' && item.value == '驳回'"
            class="redColor"
          >
            {{ item.value }}
          </div>
          <div v-else>{{ item.value }}</div>
        </div>
        <div v-else-if="item.type == 'resources'">
          <!-- 资源展示 -->
          <file-upload-list
            ref="fileUploadList"
            :fileList="item.value"
          ></file-upload-list>
        </div>
        <div v-else-if="item.type == 'vins'">
          <div class="lineTheme" @click="vinDetailClick(item.value)">查看</div>
        </div>
        <div v-else-if="item.type == 'array'" class="arrayContent">
          <p v-if="item.visible" class="headerName">{{ item.name }}</p>
          <audit-record-parse :datas="item.value"></audit-record-parse>
        </div>
      </div>
    </div>
    <vin-Info-dialog ref="vinInfoDialog" />
  </div>
</template>
<script>
import KdVinInfoDialog from "./kdVinInfoDialog.vue";
export default {
  name: "auditRecordParse",
  components: { vinInfoDialog: KdVinInfoDialog },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      baseResUrl: "",
    };
  },
  methods: {
    // vin查看
    vinDetailClick(data) {
      this.$refs.vinInfoDialog.init("故障车VIN码", data);
    },
  },
  mounted() {},
};
</script>
